import { createStore as createZustandStore, StoreApi } from 'zustand';
import * as THREE from 'three';
import { Coords, coordsToVector3 } from '@slope/utils';

export interface LngLatToSceneFn {
  (coords: Coords, altMeters?: number): THREE.Vector3Tuple;
}

export interface StoreState {
  lngLatToScene: LngLatToSceneFn;
  origin: Coords;
}

export type StoreApiState = StoreState & {
  set: StoreApi<StoreState>['setState'];
  get: StoreApi<StoreState>['getState'];
  origin: Coords;
  lngLatToScene: LngLatToSceneFn;
};

export interface StoreOptions {
  origin: Coords;
}

export type Store = StoreApi<StoreApiState>;

export const createStore = (opts: StoreOptions) =>
  createZustandStore<StoreApiState>((set, get) => ({
    ...opts,
    set,
    get,
    lngLatToScene: (coords: Coords): THREE.Vector3Tuple => {
      const origin = get().origin;
      if (!origin) {
        throw new Error('Origin not set');
      }
      return coordsToVector3(coords, origin);
    },
  }));
